import PropTypes from "prop-types"
import React from "react"
import Countdown from 'react-countdown';
import { getNewYearDayDate } from '../utils/helpers';
import {small, large, counterItem, counterNumber, counterLabel, counter} from './new-year-countdown.module.scss';

const NewYearCountdown = ({size = 'large'}) => {
    const countdownDate = getNewYearDayDate();

    const countdownRenderer = ( { days, hours, minutes, seconds } ) => {
        const getStyle = ( number, label ) => (
            <span className={ counterItem }>
                <span className={ counterNumber }>
                    { number }
                </span>
                <span className={ counterLabel }>
                    { label }
                </span>
            </span>
        );

        return (
            <span className={ `${counter} ${size === 'small' ? small : large}` }>
                {getStyle(days, 'days')}
                {getStyle(hours, 'hrs')}
                {getStyle(minutes, 'min')}
                {getStyle(seconds, 'sec')}
            </span>
        );
    };

    return (
        <Countdown date={countdownDate} renderer={countdownRenderer}/>
    )
}

NewYearCountdown.propTypes = {
    size: PropTypes.string,
}

export default NewYearCountdown;
